module.exports = __webpack_public_path__ + "static/img/ai-expert.1975bc4e.webp";